import {
  ViveApiBaseService,
  ViveApiRequestOptions
} from './vive-api-base.service';
import {
  UserDto,
  UsersCreateVendorRequestDto,
  UsersFindAllRequestDto,
  UsersFindAllResponseDto,
  UsersPasswordEmailRequestDto,
  UsersPasswordResetConfirmRequestDto,
  UsersPasswordResetRequestDto,
  UsersUpdateOneRequestDto,
  UsersVerifyResetCodeResponseDto
} from './vive-api-models';

class UsersService extends ViveApiBaseService {
  public async findAll(params: {
    options?: ViveApiRequestOptions;
    queryParams?: Omit<UsersFindAllRequestDto, 'includeAssociations'>;
  }): Promise<UsersFindAllResponseDto> {
    const { options, queryParams } = params;
    return await this.sendGet<UsersFindAllResponseDto>({
      apiEndpoint: 'users',
      options,
      queryParams
    });
  }

  public async findById(params: {
    options?: ViveApiRequestOptions;
    pathParams: { userId: number };
  }): Promise<UserDto> {
    const { options, pathParams } = params;
    return await this.sendGet<UserDto>({
      apiEndpoint: `users/:userId`,
      options,
      pathParams
    });
  }

  public async requestPasswordReset(params: {
    options?: ViveApiRequestOptions;
    data: UsersPasswordResetRequestDto;
  }): Promise<void> {
    const { options, data } = params;
    return await this.sendPost<void>({
      apiEndpoint: `users/password-reset`,
      options,
      data,
      authRequired: false
    });
  }

  public async sendPasswordEmail(params: {
    options?: ViveApiRequestOptions;
    pathParams: { userId: number };
    data: UsersPasswordEmailRequestDto;
  }): Promise<void> {
    const { options, pathParams, data } = params;
    return await this.sendPost<void>({
      apiEndpoint: `users/:userId/password-email`,
      options,
      pathParams,
      data
    });
  }

  public async verifyPasswordResetCode(params: {
    options?: ViveApiRequestOptions;
    pathParams: { code: string };
  }): Promise<UsersVerifyResetCodeResponseDto> {
    const { options, pathParams } = params;
    return await this.sendGet<UsersVerifyResetCodeResponseDto>({
      apiEndpoint: `users/password-reset/:code`,
      options,
      pathParams,
      authRequired: false
    });
  }

  public async confirmPasswordReset(params: {
    options?: ViveApiRequestOptions;
    data: UsersPasswordResetConfirmRequestDto;
  }): Promise<void> {
    const { options, data } = params;
    return await this.sendPost<void>({
      apiEndpoint: `users/password-reset/confirm`,
      options,
      data,
      authRequired: false
    });
  }

  public async createVendor(params: {
    options?: ViveApiRequestOptions;
    data: UsersCreateVendorRequestDto;
  }): Promise<UserDto> {
    const { options, data } = params;
    return await this.sendPost<UserDto>({
      apiEndpoint: `users/vendor`,
      authRequired: false,
      options,
      data
    });
  }

  public async updateById(params: {
    options?: ViveApiRequestOptions;
    pathParams: { userId: number };
    data: UsersUpdateOneRequestDto;
  }): Promise<UserDto> {
    const { options, pathParams, data } = params;
    return await this.sendPatch<UserDto>({
      apiEndpoint: `users/:userId`,
      options,
      pathParams,
      data
    });
  }
}

export const usersService = new UsersService();
